import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ChartJs from 'chart.js';

const propTypes = {
	id: PropTypes.string.isRequired,
	type: PropTypes.string,
	title: PropTypes.string,
	data: PropTypes.array,
	dataLabels: PropTypes.array,
	legendPosition: PropTypes.string,
	options: PropTypes.object,
	canvasHeight: PropTypes.number,
	canvasWidth: PropTypes.number,
};

class Chart extends Component {
	constructor() {
		super();

		this._chart = null;
	}

	componentDidMount() {
		this._createChart();
	}

	componentDidUpdate() {
		this._updateChart();
	}

	componentWillUnmount() {
		if (this._chart) {
			this._chart.destroy();
		}
	}

	_getChartOptions = () => {
		const { type, title, data, dataLabels, legendPosition, options } = this.props;
		return {
			type: type || 'line',
			data: {
				datasets: data,
				labels: dataLabels,
			},
			options: {
				elements: {
					line: {
						tension: 0
					}
				},
				responsive: true,
				legend: {
					display: true,
					position: legendPosition || 'bottom',
				},
				title: {
					display: !!title,
					text: title || ''
				},
				scales: {
					yAxes: [{
						ticks: {
							callback: (value, index, values) => this._getScaleValue(value)
						}
					}]
				},
				...options
			},
		};
	};

	_getScaleValue = (value) => {
		let i = 0;
		const sufixes = ['', 'K', 'M', 'B'];
		let newValue = value;

		while (newValue >= 1000) {
			newValue = parseFloat(newValue / 1000, 10);
			i++;
		}

		const decimal = String(newValue).indexOf('.') > -1 ? String(newValue).indexOf('.') : null;
		const difference = decimal !== null ? String(newValue).length - decimal : null;
		const finalValue = difference !== null && difference > 4 ? newValue.toFixed(4) : newValue;
		return `${finalValue} ${sufixes[i]}`;
	};

	_createChart = () => {
		const { id } = this.props;

		const elem = document.getElementById(id);
		if (elem) {
			this._chart = new ChartJs(elem, this._getChartOptions());
		}
	};

	_updateChart() {
		const { type, data, options } = this._getChartOptions();
		this._chart.type = type;
		this._chart.data = data;
		this._chart.options = options;

		this._chart.update();
	}

	render() {
		const { id, canvasHeight = null, canvasWidth = null } = this.props;

		return (
			<canvas height={canvasHeight} width={canvasWidth} id={id} />
		);
	}
}

Chart.propTypes = propTypes;

export default Chart;
